/**
 * 联系信息管理相关API接口
 */
import axios from '../axios'

const contactInfoAPI = {
  // 获取联系信息列表
  getContactInfoList(params) {
    return axios({
      url: '/contact-info',
      method: 'GET',
      params
    })
  },
  
  // 获取单个联系信息详情
  getContactInfo(id) {
    return axios({
      url: `/contact-info/${id}`,
      method: 'GET'
    })
  },
  
  // 创建联系信息
  createContactInfo(data) {
    return axios({
      url: '/contact-info',
      method: 'POST',
      data
    })
  },
  
  // 更新联系信息
  updateContactInfo(data) {
    return axios({
      url: `/contact-info/${data.id}`,
      method: 'PUT',
      data
    })
  },
  
  // 删除联系信息
  deleteContactInfo(id) {
    return axios({
      url: `/contact-info/${id}`,
      method: 'DELETE'
    })
  },
  
  // 批量删除联系信息
  batchDeleteContactInfo(ids) {
    return axios({
      url: '/contact-info/batch-delete',
      method: 'POST',
      data: { ids }
    })
  }
}

export default contactInfoAPI
